import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var toggleFacetInFacetsArray = (facets, facet) => {
  if (facets.includes(facet)) {
    return facets.filter(e => e !== facet);
  }

  return facets.concat(facet);
};

var toggleFacetInFilterBy = (filterBy, filter, facet) => {
  var {
    [filter]: filteredBy = []
  } = filterBy,
      rest = _objectWithoutProperties(filterBy, [filter].map(_toPropertyKey));

  var skeleton = toggleFacetInFacetsArray(filteredBy, facet);
  return _objectSpread(_objectSpread({}, rest), skeleton.length && {
    [filter]: skeleton
  });
};

var addUniqFacetInFilterBy = (filterBy, filter, facet) => {
  var currentFilterBy = filterBy;
  var skeleton = {};

  if (currentFilterBy[filter] && currentFilterBy[filter][0] === facet) {
    skeleton[filter] = [];
  } else {
    skeleton[filter] = [facet];
  }

  return Object.assign(currentFilterBy, skeleton);
};

export { toggleFacetInFacetsArray, toggleFacetInFilterBy, addUniqFacetInFilterBy };